import React, { useEffect } from 'react';

export function useEditModal(isOpen, room, length, width) {

  useEffect(() => {
    const onModalShow = () => {
      const first = document.getElementById('room');
      const fristValue = first?.getBoundingClientRect();
      if (isOpen && fristValue?.height) {
        first.value = room;
        document.getElementById('length').value = length;
        document.getElementById('width').value = width;
      }
    };
    onModalShow();
    window.addEventListener('DOMContentLoaded', onModalShow);
    return () => {
      window.removeEventListener('DOMContentLoaded', onModalShow);
    };
  });
}